import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-44529e1e")

_pushScopeId("data-v-44529e1e")
const _hoisted_1 = { class: "frame" }
const _hoisted_2 = { class: "image-drop-frame" }
const _hoisted_3 = {
  key: 1,
  class: "image-frame"
}
const _hoisted_4 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_drop_area = _resolveComponent("drop-area")
  const _component_loading_image = _resolveComponent("loading-image")
  const _component_icon_button = _resolveComponent("icon-button")
  const _component_multi_line_edit_box = _resolveComponent("multi-line-edit-box")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.fileFileId[_ctx.resultIndex][_ctx.kartePartsIndex].length === 0 && !_ctx.readonly)
        ? (_openBlock(), _createBlock(_component_drop_area, {
            key: 0,
            "file-types": ['image/png', 'image/jpeg'],
            onFile: _ctx.onImage
          }, {
            default: _withId(() => [
              _createTextVNode("ここに画像をドラッグ＆ドロップして下さい。(" + _toDisplayString(_ctx.MaxAttachFileMega) + "MByteまで) ", 1)
            ]),
            _: 1
          }, 8, ["onFile"]))
        : (_openBlock(), _createBlock("div", _hoisted_3, [
            (_ctx.fileMap[_ctx.fileFileId[_ctx.resultIndex][_ctx.kartePartsIndex][0]] && _ctx.fileMap[_ctx.fileFileId[_ctx.resultIndex][_ctx.kartePartsIndex][0]].base64 !== '')
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  class: "attached-image",
                  src: _ctx.fileMap[_ctx.fileFileId[_ctx.resultIndex][_ctx.kartePartsIndex][0]].base64,
                  alt: "image"
                }, null, 8, ["src"]))
              : (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode(_component_loading_image)
                ])),
            (!_ctx.readonly)
              ? (_openBlock(), _createBlock(_component_icon_button, {
                  key: 2,
                  class: "image-delete-button",
                  icon: "times",
                  state: "delete",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDeleteImage()))
                }))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createVNode(_component_multi_line_edit_box, {
      modelValue: _ctx.text[_ctx.resultIndex][_ctx.kartePartsIndex],
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.text[_ctx.resultIndex][_ctx.kartePartsIndex] = $event)),
      readonly: _ctx.readonly
    }, null, 8, ["modelValue", "readonly"])
  ]))
})